// tslint:disable-next-line:no-any
declare const process: any;

export interface AppEnv {
    APP_API_HOST?: string;
    APP_ROOT?: string;
    APP_VERSION?: string;
}

export const env: AppEnv = {
    APP_API_HOST: process.env.REACT_APP_API_HOST,
    APP_ROOT: process.env.REACT_APP_ROOT,
    APP_VERSION: process.env.REACT_APP_APP_VERSION,
};

if (process.env.REACT_APP_USE_DYNAMIC_HOST === "true" && typeof window !== "undefined") {
    env.APP_API_HOST = `${window.location.protocol}//${window.location.host}/mobi-api`;
}
console.log("Using APP_API_HOST=%s", env.APP_API_HOST);



// WEBPACK FOOTER //
// ./src/util/env.ts